<script>
export default {
  name: "base-widget",
  data() {
    return {
      dataCollection: {}
    }
  },
  methods: {
    monthRange(startDate, endDate) {
      const start      = startDate.split('-');
      const end        = endDate.split('-');
      const startYear  = parseInt(start[0]);
      const endYear    = parseInt(end[0]);
      const dates      = [];

      for(let i = startYear; i <= endYear; i++) {
        let endMonth = i !== endYear ? 11 : parseInt(end[1]) - 1;
        let startMonth = i === startYear ? parseInt(start[1]) - 1 : 0;
        for(let j = startMonth; j <= endMonth; j = j > 12 ? j % 12 || 11 : j+1) {
          let month = j + 1;
          let displayMonth = month.toString().padStart(2, '0');
          dates.push([i, displayMonth].join('.'));
        }
      }
      return dates;
    }
  },
  mounted() {
    this.dataCollection.Entries = JSON.parse(this.analyticsData);
  },
  props: ['analyticsData', 'range', 'isLoaded']
}
</script>

<style scoped>
.widgets {
  padding-top: 0 !important;
  margin-bottom: 0;
}

.widgets .v-card__title {
  display: block;
  text-align: center;
  margin-top: 5px;
  font-family: Montserrat, sans-serif;
}

.widgets .v-card__title .headline {
  font-size: 18px;
  font-weight: bold;
}
</style>
